import SmartLink from "@/components/marketing/smart-link";

function renderAction(action, index) {
  const {
    href,
    label,
    icon,
    className = "btn btn-primary"
  } = action;

  return (
    <SmartLink key={`${label}-${index}`} href={href} className={className}>
      {icon ? <i className={`${icon} me-2`} aria-hidden="true" /> : null}
      <span>{label}</span>
    </SmartLink>
  );
}

export default function PageHero({ title, copy, actions = [], size = "default", narrow = false, imageSrc = null, imagePosition = "center" }) {
  const compact = size === "compact";
  const panelStyle = imageSrc
    ? {
        "--public-page-hero-image": `url(${imageSrc})`,
        "--public-page-hero-image-position": imagePosition
      }
    : undefined;

  return (
    <section className={`public-page-hero ${compact ? "public-page-hero--compact" : ""} ${narrow ? "public-page-hero--narrow" : ""} ${imageSrc ? "public-page-hero--image" : ""}`}>
      <div className={`public-page-hero__panel ${compact ? "is-compact" : ""}`} style={panelStyle}>
        <div className="public-container">
          <div className="public-page-hero__inner">
            <div className={`public-page-hero__content ${compact ? "is-compact" : ""}`}>
              <h1 className="public-page-hero__title">{title}</h1>
              <p className="public-page-hero__copy">{copy}</p>

              {actions.length > 0 ? (
                <div className="public-page-hero__actions">
                  {actions.map(renderAction)}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
